import { render, staticRenderFns } from "./House.vue?vue&type=template&id=564c49b8&"
import script from "./House.vue?vue&type=script&lang=js&"
export * from "./House.vue?vue&type=script&lang=js&"
import style0 from "./House.vue?vue&type=style&index=0&id=564c49b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports